/**
 * Pick props from an object and return the picked props and the rest.
 *
 * @param obj The object to pick props from
 *
 * @param keys The keys to pick
 *
 * @example
 *
 * const obj = { a: 1, b: 2, c: 3 };
 *
 * const [picked, rest] = pickProps(obj, ['a', 'b']);
 *
 */
export const pickProps = <T extends object, K extends keyof T = keyof T>(
  obj: object,
  keys: K[]
): [Pick<T, K>, Omit<T, K>] =>
  keys.reduce(
    (acc, key) => {
      if (key in obj) {
        const { [key]: picked, ...rest } = acc[1];
        return [{ ...acc[0], [key]: picked }, rest];
      }
      return acc as any;
    },
    [{} as Pick<T, K>, { ...obj } as Omit<T, K>]
  );
